import { GeekItem } from '@/models';
import { LevelEntity, NewOpportunity, Tag, Department, Level } from '@/models/opportunities';
import { dateRangeMixin } from '@/shared';
import { Actions, typedStore } from '@/store';
import { buildGeekFullName } from '@/utils';
import Multiselect from 'vue-multiselect';
import mixins from 'vue-typed-mixins';

export const opportunityFormMixin = mixins(dateRangeMixin).extend({
  name: 'OpportunityEditView',
  components: {
    Multiselect,
  },
  data() {
    return {
      form: {
        approvers: [] as GeekItem[],
        subject: '' as string,
        levelId: '' as string,
        vacancies: null as unknown as number,
        tags: [] as any,
        departmentId: '' as string,
        shortDescription: '' as string,
        longDescription: '' as string,
        expectedOutput: '' as string,
        gCoinsAward: null as unknown as number,
        gxpAward: null as unknown as number,
      } as NewOpportunity,
      loader: {
        isOpportunityCreateRequestSending: false as boolean,
        isOpportunityCreateRequestFormPending: true as boolean,
      },
    };
  },
  async created(): Promise<void> {
    try {
      await Promise.all([
        this.$store.dispatch(Actions.opportunities.fetchDepartments),
        this.$store.dispatch(Actions.opportunities.fetchLevels),
        this.$store.dispatch(Actions.opportunities.fetchApprovers),
      ]);
      this.form.levelId = this.levels.find(
        l => l.name === Level.Simple.charAt(0).toUpperCase() + Level.Simple.slice(1),
      )!.id;
      await this.$store.dispatch(Actions.opportunities.fetchTags);
    } finally {
      this.loader.isOpportunityCreateRequestFormPending = false;
    }
  },
  computed: {
    tagOptions(): Tag[] {
      return typedStore(this).state.opportunities.tags;
    },
    approvers(): GeekItem[] {
      return typedStore(this).state.opportunities.approvers;
    },
    levels(): LevelEntity[] {
      return typedStore(this).state.opportunities.levels;
    },
    departments(): Department[] {
      return typedStore(this).state.opportunities.departments;
    },
  },
  methods: {
    addTag(newTag: string) {
      const tag: Tag = {
        id: null as unknown as string,
        value: newTag,
      };
      this.tagOptions.push(tag);
      this.form.tags.push(tag);
    },
    isMaxLengthRuleBroken(field: string): boolean {
      return Array.from((this as any).errors).some((e: any) => e.field === field && e.rule === 'max');
    },
    getAwardRule(prop: string): string {
      return `between:0,${this.getFieldMaxValue(prop)}`;
    },
    getFieldMaxValue(prop: string): number | null {
      const foundLevel: LevelEntity & any = this.levels.find((l: LevelEntity) => l.id === this.form.levelId);
      if (foundLevel) {
        return foundLevel[prop];
      }
      return null;
    },
    deleteApprover(approver: GeekItem) {
      const approverIndex = this.form.approvers.findIndex(a => a.id === approver.id);
      this.form.approvers.splice(approverIndex, 1);
    },
    buildGeekFullName,
  },
});
